import { AppThunk } from '../../../store/rootReducer';
import * as annotationClient from '../clients/annotation.client';
import * as annotationTaskActions from '../actions/annotation-task.actions';

export const retrieveLatestAnnotation =
  (ecgId: string): AppThunk<Promise<void>> =>
  async (dispatch) => {
    const annotation = await annotationClient.getLatestAnnotationForEcg(ecgId);
    dispatch(annotationTaskActions.setAnnotation({ annotation }));
  };
